import React, { useEffect, useState } from 'react';

interface IconProps {
  name: string;
  alt?: string;
  width?: string;
  height?: string;
  className?: string;
}

const Icon: React.FC<IconProps> = ({ name, alt, width, height, className = '' }) => {
  const [iconUrl, setIconUrl] = useState<string>('');

  useEffect(() => {
    const fetchIcon = async () => {
      setIconUrl(`${window.location.origin}/images/icons/${name}.svg`);
    };

    fetchIcon();
  }, [name]);

  const imgProps = {
    src: iconUrl,
    ...(alt && { alt }),
    ...(width && { width }),
    ...(height && { height }),
    className: `icon ${className}`,
  };

  if (!iconUrl) {
    return null;
  }

  return <img {...imgProps} />;
};

export default Icon;
